import React, { useState } from 'react';
import { useTransition, animated } from 'react-spring'

import Header from './Header';
import Navigation from './navigation';
import Question from './Question';
import Finished from './Finished';
import questionData from './QuizData';


const App = () => {
  const [previousQuestion, setPreviousQuestion] = useState(1);
  const [activeQuestion, setActiveQuestion] = useState(1);
  const [responces, setResponces] = useState([]);
  const [responcesProgress, setResponcesProgress] = useState(0);

  // Navigate quiz questions
  const actionPrevQuestion = () => {
    setPreviousQuestion(activeQuestion);
    setActiveQuestion(activeQuestion - 1);
  }
  const actionNextQuestion = () => {
    setPreviousQuestion(activeQuestion);
    setActiveQuestion(activeQuestion + 1);
  }

  // Set responce
  const setAnswer = (q, a) => {
    const newResponces = [...responces];
    newResponces[q - 1] = a;
    setResponces(newResponces);

    // Update quiz progress
    if (q > responcesProgress) {
      setResponcesProgress(q);
    }
  }



  const transitions = useTransition(activeQuestion, p => p, {
    from: {
      position: 'relative',
      width: '100%',
      top: 0,
      opacity: 0,
      transform: `translate(${(activeQuestion - previousQuestion) * 100}%,0)`
    },
    enter: { opacity: 1, transform: 'translate(0%,0)' },
    leave: { position: 'absolute', opacity: 0, transform: `translate(${(previousQuestion - activeQuestion) * 100}%,0)` }
  });

  return (
    <>
      <div className="quiz">
        <Header />
        <div class="row quiz--wrapper">
          <div class="col-12">

            {transitions.map(({ item, props, key }) => (
              <animated.div key={key} style={props}>
                {item.component}

                {(activeQuestion <= questionData.length) ? (
                  <Question activeQuestion={activeQuestion} setAnswer={setAnswer} responces={responces} />
                ) : (
                  <Finished responces={responces} />
                )}

              </animated.div>
            ))}
          </div>
        </div>
      </div>

      <Navigation
        activeQuestion={activeQuestion}
        responcesProgress={responcesProgress}
        actionPrevQuestion={actionPrevQuestion}
        actionNextQuestion={actionNextQuestion}
      />
    </>
  );
};

export default App;
